/*
 * rheincool — Karten-ATC (rc-quick-add)
 * Legt die Basis-Variante per /cart/add.js in den Warenkorb, aktualisiert
 * Cart-Badge + Drawer über Section Rendering und zeigt „✓ Hinzugefügt".
 */
class RcQuickAdd extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-variant-id]');
    if (!this.button) return;
    this.button.addEventListener('click', () => this.add());
  }

  async add() {
    this.button.disabled = true;
    try {
      const response = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(this.button.dataset.variantId, 10), quantity: 1 }],
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'add_failed');

      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && data.sections && data.sections['cart-icon-bubble']) {
        bubble.innerHTML = new DOMParser()
          .parseFromString(data.sections['cart-icon-bubble'], 'text/html')
          .body.innerHTML;
        bubble.querySelector('.cart-count-bubble')?.classList.add('is-pulsing');
      }
      const drawer = document.querySelector('cart-drawer');
      if (drawer && data.sections && data.sections['cart-drawer']) {
        const inner = new DOMParser()
          .parseFromString(data.sections['cart-drawer'], 'text/html')
          .querySelector('cart-drawer');
        if (inner) drawer.innerHTML = inner.innerHTML;
        drawer.classList.remove('is-empty');
        if (typeof drawer.open === 'function') drawer.open({ success: true });
      }

      const original = this.button.textContent;
      this.button.classList.add('is-added');
      this.button.textContent = this.button.dataset.addedText || '✓';
      setTimeout(() => {
        this.button.classList.remove('is-added');
        this.button.textContent = original;
      }, 2000);

      if (window.rcTrack) window.rcTrack('add_to_cart', { option: 'nur-geraet', quelle: 'card' });
    } catch (error) {
      console.warn('[rc-quick-add]', error);
    } finally {
      this.button.disabled = false;
    }
  }
}

customElements.define('rc-quick-add', RcQuickAdd);
